(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-logo-carousel').each(function () {
			const sliderEl = $(this)[0];

			const swiper = new Swiper('.js-logo-carousel', {
				direction: 'horizontal',
				slidesPerView: 3,
				preventInteractionOnTransition: true,
				spaceBetween: 20,
				speed: 8000,
				simulateTouch: false,
				loop: true,
				autoplay: {
					delay: 0,
				},

				breakpoints: {
					414: {
						slidesPerView: 4,
					},
					640: {
						spaceBetween: 40,
					},
					744: {
						slidesPerView: 5,
						spaceBetween: 40,
					},
					1024: {
						slidesPerView: 6,
						spaceBetween: 40,
					},
					1280: {
						slidesPerView: 7,
						spaceBetween: 60,
					},
					1440: {
						slidesPerView: 8,
						spaceBetween: 80,
					}
				},

				on: {
					init: function () {
						sliderEl.classList.remove('swiper-uninitialized');
					},

					resize: function () {
						this.autoplay.start();
					},
				}
			});
		});
	});
})(jQuery, document, window);
